import React from "react";
import { profile } from "@/lib/data";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative border-t border-term-green/20 bg-bg-surface/40"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="font-mono text-xs text-ink-tertiary">
                    <span className="text-term-green">●</span>{" "}
                    {profile.name} ·{" "}
                    <span className="text-ink-secondary">{profile.title}</span>
                </div>
                <div className="font-mono text-[11px] text-ink-tertiary uppercase tracking-[0.22em]">
                    <span className="text-term-green">$</span> printf &quot;%s\n&quot; &quot;Built with Super Computer&quot;
                </div>
                <div className="font-mono text-[11px] text-ink-tertiary">
                    © {new Date().getFullYear()} · all systems nominal
                </div>
            </div>
        </footer>
    );
}
